import { DEFAULT_HEADER_DATA } from './constants';
import { IClient } from './types';

const Client: IClient = {
  api: {},
  headers: DEFAULT_HEADER_DATA,
  locale: 'en',
  defaultLocale: 'en',
  setUpdatedHeader: () => {
    // setting default as empty implementation to fix sonar linting issue.
  },
};

export default Client;
